import gql from "graphql-tag";

export default gql`
	fragment PlanDetails on PlanWithPrices {
		planCode
		name
		prices {
			subscriptionSize
			price
			betterOption
		}
	}

	query getThreePlanPrices {
		studentPlan: getPlanWithPrices(planCode: "sg_student_yearly", maxSeats: 1) {
			...PlanDetails
		}
		academicPlan: getPlanWithPrices(planCode: "sg_academic_yearly") {
			...PlanDetails
		}
		corporatePlan: getPlanWithPrices(planCode: "sg_corporate_yearly") {
			...PlanDetails
		}
	}
`;

export const readThreePlanPrices = ({ data }) => data;
